import React from "react";
import { Slider as AntdSlider } from "antd";
import "./style.scss";
import { retrieveToken } from "utils/storage";

function Slider({
  variant = "age",
  defaultValue,
  value,
  onChange,
  minValue,
  maxValue,
  title = true,
  footer = true,
  className,
}) {
  const userGender = JSON.parse(retrieveToken("user"));
  const gender = userGender?.gender;
  const minAge = gender?.toLowerCase() === "female" ? 21 : 18;
  const config = {
    age: {
      min: minValue ?? minAge,
      max: maxValue ?? 70,
      unit: "years",
    },
    height: {
      min: minValue ?? 100,
      max: maxValue ?? 220,
      unit: "cm",
    },
    weight: {
      min: minValue ?? 45,
      max: maxValue ?? 100,
      unit: "kg",
    },
  };

  const { min, max, unit } = config[variant];
  const displayRange = value || defaultValue || [min, max];

  // Labels dynamically based on current slider values (displayRange)
  const labelMin = `Min ${displayRange[0]} ${unit}`;
  const labelMax = `Max ${displayRange[1]} ${unit}`;

  return (
    <div className="slider-container">
      {title && (
        <h4 className="slider-title">
          {displayRange[0]} - {displayRange[1]} {unit}
        </h4>
      )}
      <div className="slider-wrapper">
        <AntdSlider
          range
          min={min}
          max={max}
          value={displayRange}
          onChange={onChange}
          className={className}
        />
        {footer && (
          <div className="slider-labels-wrapper">
            <span className="slider-labels">{labelMin}</span>
            <span className="slider-labels">{labelMax}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default Slider;
